import React, { useState, useEffect, CSSProperties } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm";

import $ from "jquery";
interface DoctorScheduleRow {
  scheduleId: string;
  calendarOptionType: "Appointment" | "Availability" | "Non-Availability"; // adjust if needed
  // Include other fields from the API if needed
  date: string;
  startTime: string;
  endTime: string;
  // etc.
}
// Define the DataTableProps interface
interface DataTableProps {
  headers: {
    key: string;
    label: string;
    sortable?: boolean;
    items?: any;
    style?: any;
    isNumeric?: boolean;
  }[];
  rows?: any[];
  onAction?: (action: string, row: any) => void;
  onSortAction?: (row: any, action?: string) => void;
  onFileAction?: (action: string, row: any) => void;
  onDownloadAction?: (action: string, row: any) => void;
  isLogTable?: boolean;
  isTodayAppointmentTable?: boolean;
  isUpcomingAppointmentTable?: boolean;
  isPastAppointmentTable?: boolean;
  radioSelection?: boolean;
  onRadioSelect?: (row: any) => void; // ✅ This line
  onRowSelect?: (row: any) => void;
  selectedRow?: any;
  selectedRowRadio?: any;
  isCheckbox?: boolean;
  onCheckboxSelect?: (selectedRows: any[]) => void;
  selectedRowIds?: any;
  disabled?: boolean;
  isDoctorSchedule?: boolean;
}

const DataTable: React.FC<DataTableProps> = ({
  headers,
  rows = [],
  onAction,
  onSortAction,
  onFileAction,
  onDownloadAction,
  isLogTable = false,
  isTodayAppointmentTable,
  isUpcomingAppointmentTable,
  isPastAppointmentTable,
  radioSelection = false,
  onRadioSelect,
  onRowSelect,
  selectedRow,
  isCheckbox = false,
  onCheckboxSelect,
  selectedRowIds = [],
  disabled = false,
  isDoctorSchedule,
}) => {
  const [sortedRows, setSortedRows] = useState<any[]>(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ASC" | "DESC" | null;
  }>({
    key: "",
    direction: null,
  });

  const tableStyle = {
    border: "1px solid #ddd",
    borderCollapse: "collapse" as const,
    width: "100%",
    tableLayout: "fixed",
  };

  const thStyle: CSSProperties = {
    border: "none",
    padding: "8px",
    backgroundColor: "#e0f7fa",
    color: "#000",
    cursor: "pointer",
    position: "sticky", // ✅ This will now work correctly
    top: 0,
    zIndex: -90,
  };

  const tdStyle = {
    border: "none",
    padding: "8px",
  };

  const handleSort = (key: string, direction: "ASC" | "DESC") => {
    if (sortConfig.key === key && sortConfig.direction === direction) {
      return; // Prevent clicking on the same active sort direction
    }
    const sorted = [...sortedRows].sort((a, b) => {
      if (direction === "ASC") {
        return a[key] > b[key] ? 1 : -1;
      }
      if (direction === "DESC") {
        return a[key] < b[key] ? 1 : -1;
      }
      return 0;
    });

    setSortedRows(sorted);
    setSortConfig({ key, direction });
    onSortAction?.({ key, direction });
  };

  useEffect(() => {
    if (
      isCheckbox &&
      rows?.length > 0 &&
      selectedRowIds?.length > 0 &&
      Array.isArray(selectedRowIds)
    ) {
      const cleanedIds = selectedRowIds?.map((id: string) => id?.trim());
      const selectedIdSet = new Set(cleanedIds);

      const selected = rows?.filter((row) => selectedIdSet.has(String(row.id)));

      const unselected = rows?.filter(
        (row) => !selectedIdSet.has(String(row.id))
      );

      const ordered = [...selected, ...unselected];

      setSortedRows(ordered);
      setSelectedRows(selected);
      const allSelected = rows?.length > 0 && selected?.length === rows?.length;
      setSelectAll(allSelected);
    } else {
      setSortedRows(rows || []);
      setSelectedRows([]);
    }
  }, [rows]);
  
const handleSelectAll = () => {
  const newSelectAll = !selectAll;

  const now = new Date();

  // Filter only future or current rows
  const updated = newSelectAll
    ? sortedRows.filter((row) => {
        const dateParts = row.dateOfAppointment.split(" - ")[0]; // "07/02/2025"
        const dateTimeStr = `${dateParts} ${row.startTime}`; // "07/02/2025 16:30:00"
        const rowDate = new Date(dateTimeStr);
        return rowDate >= now;
      })
    : [];

  setSelectedRows(updated);
  setSelectAll(newSelectAll);
  onCheckboxSelect?.(updated);

  if (newSelectAll) {
    const selectedRowsForPopup = updated;

    const allAppointments = selectedRowsForPopup.every(
      (row) => row.calendarOptionType === "Appointment"
    );
    const allAvailable = selectedRowsForPopup.every(
      (row) =>
        row.calendarOptionType === "Availability" ||
        row.calendarOptionType === "Non-Availability"
    );

    if (allAppointments) {
      setSelectedType("Appointment");
    } else if (allAvailable) {
      setSelectedType("Available");
    } else {
      setSelectedType(null);
    }

    $.confirm({
      title: "Schedule Type",
      content: `
        <div class="d-flex justify-content-center my-2">
          <label class="mx-4">
            <input type="radio" name="scheduleType" value="Appointment" />
            Appointment
          </label>
          <label>
            <input type="radio" name="scheduleType" value="Available" />
            Available / Not Available
          </label>
        </div>
      `,
      buttons: {
        no: {
          text: "<span class='material-icons'>close</span> Cancel",
          btnClass: "btn btn-outline-info d-flex align-items-center",
        },
        confirm: {
          text: "<span class='material-icons'>check</span> Confirm",
          btnClass: "btn-primary d-flex align-items-center",
          action: function (this: any) {
            const selectedValue = this.$content
              .find('input[name="scheduleType"]:checked')
              .val();

            if (selectedValue) {
              setSelectedType(selectedValue);

              const filteredRows = updated.filter((row) =>
                selectedValue === "Available"
                  ? row.calendarOptionType === "Availability" ||
                    row.calendarOptionType === "Non-Availability"
                  : row.calendarOptionType === "Appointment"
              );

              setSelectedRows(filteredRows);
              onCheckboxSelect?.(filteredRows);
            } else {
              $.alert("Please select a schedule type.");
              return false;
            }
          },
        },
      },
    });
  }
};


  useEffect(() => {
    setSortedRows(rows || []);
    setDoctorSchedule(rows || []); // <-- Fix: sync doctorSchedule with rows
  }, [rows]);

  const handleCheckboxChange = (row: any) => {
    const isSelected = selectedRows.some((r) => r.id === row.id);
    const updated = isSelected
      ? selectedRows.filter((r) => r.id !== row.id)
      : [...selectedRows, row];
    setSelectedRows(updated);
    setSelectAll(updated.length === sortedRows.length);
    onCheckboxSelect?.(updated);
    determineAndShowScheduleType(updated);
  };
  const [doctorSchedule, setDoctorSchedule] = useState<DoctorScheduleRow[]>([]);

  // const [selectedType, setSelectedType] = useState<'Appointment' | 'Available' | 'Not Available' | null>(null);

  //   const allRowsSameType = doctorSchedule
  //   .filter((row:any) => selectedRowIds.includes(row.scheduleId))
  //   .every((row:any) => row.calendarOptionType === 'Appointment');

  // setSelectedType(allRowsSameType ? 'Appointment' : 'Available');

  const [selectedType, setSelectedType] = useState<
    "Appointment" | "Available" | null
  >(null);
  const [showTypePopup, setShowTypePopup] = useState(false);

  const determineAndShowScheduleType = (selected: any[]) => {
    if (selected.length === 0) {
      setSelectedType(null);
      setShowTypePopup(false);
      return;
    }

    const allAppointments = selected.every(
      (row) => row.calendarOptionType === "Appointment"
    );
    const allAvailable = selected.every(
      (row) =>
        row.calendarOptionType === "Available" ||
        row.calendarOptionType === "Not Available"
    );

    if (allAppointments) {
      setSelectedType("Appointment");
    } else if (allAvailable) {
      setSelectedType("Available");
    } else {
      setSelectedType(null); // Mixed selection
    }

    setShowTypePopup(true); // Show the popup
  };

  {
    showTypePopup && (
      <div style={{ marginBottom: "1rem" }}>
        <label style={{ fontWeight: "bold", marginRight: "1rem" }}>
          Schedule Type:
        </label>
        <input
          type="radio"
          id="appointment"
          name="scheduleType"
          value="Appointment"
          checked={selectedType === "Appointment"}
          onChange={() => setSelectedType("Appointment")}
        />
        <label htmlFor="appointment" style={{ marginRight: "1rem" }}>
          Appointment
        </label>

        <input
          type="radio"
          id="available"
          name="scheduleType"
          value="Available"
          checked={selectedType === "Available"}
          onChange={() => setSelectedType("Available")}
        />
        <label htmlFor="available">Available / Not Available</label>
      </div>
    );
  }

  return (
    <div className="table-responsive border-0 mb-2">
      <Table style={{ tableLayout: "fixed" }}>
        <thead>
          <tr>
            {radioSelection && <th style={{ width: "5%" }} />}

            {isCheckbox && (
              <th style={{ width: "5%", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  disabled={disabled || isDoctorSchedule}
                />
              </th>
            )}

            {headers.map((header) => (
              // <th key={header.key} style={thStyle}>
              <th
                key={header.key}
                style={{
                  border: "none",
                  padding: "8px",
                  backgroundColor: "#e0f7fa",
                  color: "#000",
                  cursor: header.sortable ? "pointer" : "default",
                  position: "sticky",
                  top: 0,
                  zIndex: -90,

                  textAlign: [
                    "isActiveDetails",
                    "appointmentStatusDesc",
                    "actions",
                    "phonenumber",
                    "download",
                  ].includes(header.key)
                    ? "center"
                    : "left",
                  ...header.style,
                }}
              >
                <div
                  style={{
                    display: [
                      "isActiveDetails",
                      "appointmentStatusDesc",
                      "actions",
                      "phonenumber",
                      "contactphonenumber",
                      "download",
                    ].includes(header.key)
                      ? "flex"
                      : "flex",

                    justifyContent: [
                      "isActiveDetails",
                      "appointmentStatusDesc",
                      "actions",
                      "phonenumber",
                      "contactphonenumber",
                      "download",
                    ].includes(header.key)
                      ? "space-evenly"
                      : "space-between",

                    alignItems: "center",
                  }}
                >
                  <span>{header.label}</span>
                  {header.sortable && (
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginLeft: "4px",
                        cursor: "pointer",
                        position: "absolute",
                        right: "0px",
                      }}
                    >
                      {!(
                        sortConfig.key === header.key &&
                        sortConfig.direction === "ASC"
                      ) && (
                        <span
                          className="material-icons"
                          style={{
                            fontSize: "18px",
                            lineHeight: "10px",
                          }}
                          onClick={() => handleSort(header.key, "ASC")}
                        >
                          arrow_drop_up
                        </span>
                      )}
                      {!(
                        sortConfig.key === header.key &&
                        sortConfig.direction === "DESC"
                      ) && (
                        <span
                          className="material-icons"
                          style={{
                            fontSize: "18px",
                            lineHeight: "10px",
                          }}
                          onClick={() => handleSort(header.key, "DESC")}
                        >
                          arrow_drop_down
                        </span>
                      )}
                    </span>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedRows?.length > 0 ? (
            sortedRows.map((row, index) => (
              <tr
                key={row.id}
                style={{
                  backgroundColor: index % 2 === 1 ? "white" : "#f2f2f2",
                }}
              >
                {radioSelection && (
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="radio"
                      name="rowSelect"
                      checked={
                        selectedRow?.original?.scheduleId ===
                        row.original?.scheduleId
                      }
                      onChange={() => {
                        onRadioSelect?.(row); // ✅ Call the prop
                      }}
                    />
                  </td>
                )}

                {isCheckbox && (
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selectedRows.some((r) => r.id === row.id)}
                      onChange={() => handleCheckboxChange(row)}
                      disabled={row.disabled || isDoctorSchedule}
                    />
                  </td>
                )}

                {headers.map((header) => {
                  if (header.key === "isActiveDetails") {
                    return (
                      <td
                        key={header.key}
                        className="text-center"
                        style={{
                          color:
                            row.isActiveDetails === "Yes"
                              ? "#0d6efd"
                              : "#EE3339",
                          textAlign: "center",
                        }}
                      >
                        {row.isActiveDetails}
                      </td>
                    );
                  }

                  if (header.key === "appointmentStatusDesc") {
                    return (
                      <td
                        key={header.key}
                        className="text-center"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {row.appointmentStatusDesc}
                      </td>
                    );
                  }

                  if (header.key === "fileAction") {
                    return (
                      <td key={header.key} style={{ padding: "8px" }}>
                        {row.fileAction && (
                          <>
                            <span className="attachfile">
                              <span
                                className="material-icons mx-1 color_brand text-dark"
                                onClick={() =>
                                  onFileAction?.(row, "fileAction")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                attachment
                              </span>
                              {row.fileAction}
                            </span>
                          </>
                        )}
                      </td>
                    );
                  }

                  if (header.key === "download") {
                    return (
                      <td key={header.key} style={{ padding: "8px" }}>
                        {row.download && (
                          <span
                            className="material-icons color_brand"
                            onClick={() => onDownloadAction?.(row, "download")}
                            style={{ cursor: "pointer" }}
                          >
                            download
                          </span>
                        )}
                      </td>
                    );
                  }

                  if (header.key === "actions") {
                    return (
                      <td key={header.key} style={{ padding: "8px" }}>
                        {row.actions?.View && (
                          <OverlayTrigger
                            placement="auto"
                            delay={{ show: 200, hide: 10 }}
                            overlay={
                              <Tooltip
                                id={`view-tooltip-${row.id}`}
                                style={{ backgroundColor: "#b3e0ff" }}
                              >
                                View
                              </Tooltip>
                            }
                          >
                            <span
                              className="material-icons color_brand"
                              onClick={() => onAction?.(row, "View")}
                              style={{ cursor: "pointer" }}
                            >
                              visibility
                            </span>
                          </OverlayTrigger>
                        )}
                        {row.actions?.Edit && (
                          <OverlayTrigger
                            placement="auto"
                            delay={{ show: 200, hide: 10 }}
                            overlay={
                              <Tooltip
                                id={`edit-tooltip-${row.id}`}
                                style={{ backgroundColor: "#b3e0ff" }}
                              >
                                Edit
                              </Tooltip>
                            }
                          >
                            <span
                              className="material-icons color_brand"
                              onClick={() => onAction?.(row, "Edit")}
                              style={{ cursor: "pointer" }}
                            >
                              edit
                            </span>
                          </OverlayTrigger>
                        )}
                      </td>
                    );
                  }

                  const cellContent = row[header.key];
                  return (
                    <td
                      key={header.key}
                      style={{
                        padding: header.isNumeric
                          ? "8px 20px 8px 8px !important"
                          : "8px",
                        textAlign: header.isNumeric ? "center" : "left",
                      }}
                    >
                      <OverlayTrigger
                        placement="auto"
                        delay={{ show: 200, hide: 10 }}
                        overlay={
                          cellContent &&
                          cellContent?.length > (isLogTable ? 60 : 15) ? (
                            <Tooltip
                              id={`tooltip-${header.key}-${row.id}`}
                              style={{ backgroundColor: "#b3e0ff" }}
                            >
                              {cellContent}
                            </Tooltip>
                          ) : (
                            <></>
                          )
                        }
                      >
                        <span
                          // className= 'd-inline-block text-truncate'
                          className={`d-inline-block ${
                            !isLogTable ? "text-truncate" : ""
                          }`}
                          style={{
                            maxWidth: isLogTable ? "none" : "100%",
                            cursor: isLogTable ? "default" : "pointer",
                          }}
                        >
                          {cellContent}
                        </span>
                      </OverlayTrigger>
                    </td>
                  );
                })}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers?.length} style={{ textAlign: "center" }}>
                <span className="no_rec_data">
                  {" "}
                  {isTodayAppointmentTable
                    ? "No Appointments Scheduled for Today"
                    : isUpcomingAppointmentTable
                    ? "No Appointments Scheduled"
                    : isPastAppointmentTable
                    ? "No Appointments"
                    : "No Record Found"}
                </span>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default DataTable;
